<template>
  <div>
    <v-container fluid class="px-6 py-6">
      <v-row>
        <v-stepper
          alt-labels
          elevation="0"
          v-model="e1"
          class="bg-transparent overflow-visible w-100 mx-auto"
        >
          <!-- <v-row>
              <v-col cols="12" class="mx-auto mt-3">
                <v-stepper-header class="shadow-0">
                  <v-stepper-step step="1" color="#0A3542">
                    <span class="text-secondary font-weight-normal">Project</span>
                  </v-stepper-step>
  
                  <v-divider></v-divider>
  
                  <v-stepper-step step="2" color="#0A3542">
                    <span class="text-secondary font-weight-normal">Purpose</span>
                  </v-stepper-step>
  
                  <v-divider></v-divider>
  
                  <v-stepper-step step="3" color="#0A3542">
                    <span class="text-secondary font-weight-normal">Brands</span>
                  </v-stepper-step>
  
                  <v-divider></v-divider>
  
                  <v-stepper-step step="4" color="#0A3542">
                    <span class="text-secondary font-weight-normal">Competitors</span>
                  </v-stepper-step>
  
                  <v-divider></v-divider>
  
                  <v-stepper-step step="5" color="#0A3542">
                    <span class="text-secondary font-weight-normal">Goals</span>
                  </v-stepper-step>
                </v-stepper-header>
              </v-col>
            </v-row>
   -->
          <v-row>
            <v-col lg="8" cols="12" class="mx-auto">
              <v-stepper-items
                class="border-radius-xl overflow-hidden shadow-lg mt-5 mb-9"
              >
                <v-stepper-content
                  step="1"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <h5
                            class="text-h3 text-center font-weight-normal my-2"
                          >
                            Try it Now
                          </h5>
                          <!--                          <p class="text-body">-->
                          <!--                            One thing I love about the later sunsets is the-->
                          <!--                            chance to go for a walk through the neighborhood-->
                          <!--                            woods before dinner-->
                          <!--                          </p>-->
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                      <v-row class="mt-2">
                        <v-col cols="1" />
                        <v-col cols="10">
                          <v-container fluid>
                            <v-text-field
                              filled
                              v-model="email"
                              label="Email"
                            ></v-text-field>
                            <div class="text-end">
                              <v-btn
                                :ripple="false"
                                :elevation="0"
                                class="
                                  font-weight-bold
                                  text-xs
                                  btn-default
                                  bg-gradient-default
                                  py-5
                                  px-6
                                  mt-2
                                  mb-2
                                  me-2
                                "
                                block
                                color="primary"
                                @click="e1 = 2"
                              >
                                Next
                              </v-btn>
                            </div>
                            <v-row class="mt-3">
                              <v-col cols="5">
                                <v-divider class="mt-3"></v-divider>
                              </v-col>
                              <v-col cols="2" class="text-center">
                                <span class="font-weight-bold">OR</span>
                              </v-col>
                              <v-col cols="5">
                                <v-divider class="mt-3"></v-divider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="2"> </v-col>
                              <v-col cols="8">
                                <div class="text-center">
                                  <div>
                                    Have an account? <a href="#">Log in</a>
                                  </div>
                                  <div class="text-xs mt-10">
                                    By continuing, you agree to our Terms,
                                    Conditions, and Policies
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="2"> </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="2"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card class="pt-8">
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="5" class="mx-auto">
                          <v-text-field
                            filled
                            v-model="firstName"
                            label="First Name"
                          ></v-text-field>
                          <v-text-field
                            filled
                            v-model="lastName"
                            label="Last Name"
                          ></v-text-field>
                          <v-text-field
                            filled
                            v-model="email"
                            label="Email"
                          ></v-text-field>
                          <v-text-field
                            filled
                            v-model="phoneNumber"
                            label="Phone Number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5" class="mt-1">
                          <label class="font-weight-bolder">
                            Type of account:
                          </label>
                          <v-radio-group v-model="accountType">
                            <v-radio
                              label="Individual"
                              value="individual"
                              selected
                            ></v-radio>
                            <v-radio label="Company" value="company"></v-radio>
                          </v-radio-group>
                          <v-text-field
                            filled
                            v-if="accountType === 'company'"
                            v-model="company"
                            label="Company"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 1"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 3"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="3"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What are your brand names?
                          </h5>
                          <p class="text-body text-sm">
                            Be as comprehensive as you can if the name is used
                            as a trademark, even for a specific product.
                          </p>
                          <v-textarea solo placeholder="" value="" />
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 2"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 4"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="4"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What are the brand names you compete against?
                          </h5>
                          <p class="text-body text-sm">
                            Be as comprehensive as you can if the name is used
                            as a trademark, even for a specific product.
                          </p>
                          <v-textarea
                            solo
                            placeholder="Be as comprehensive as you can be, but you can always edit this selection later, so don't sweat it too much."
                            value=""
                          />
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 3"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                        @click="e1 = 5"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="5"
                  class="bg-white border-radius-xl px-4 pt-4"
                >
                  <v-card>
                    <div>
                      <v-row class="text-left">
                        <v-col cols="1" />
                        <v-col cols="10" class="mx-auto">
                          <v-icon
                            large
                            color="black"
                            class="float-left my-1 mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                          <h5 class="text-h4 font-weight-normal mb-2">
                            What's the Conversion Goal?
                          </h5>
                          <p class="text-body text-sm">
                            What action do you want your ideal customer to take?
                          </p>
                          <v-textarea
                            solo
                            placeholder="What I want customers to do.  Here are some examples...
  ˖  Request information with a form
  ˖  Make a purchase
  ˖  Call our office"
                            value=""
                          />
                          <v-btn
                            :ripple="false"
                            :elevation="0"
                            class="
                              font-weight-bold
                              text-xs text-dark
                              btn-light
                              py-5
                              px-6
                              mt-6
                              mb-2
                              ms-2
                            "
                          >
                            Give Me Ideas *
                          </v-btn>
                          <p class="text-body text-xs ml-3 font-italic">
                            * Ideas are generated by AI
                          </p>
                        </v-col>
                        <v-col cols="1" />
                      </v-row>
                    </div>
                    <div class="d-flex mt-10">
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs text-dark
                          btn-light
                          bg-gradient-light
                          py-5
                          px-6
                          mt-6
                          mb-2
                          ms-2
                        "
                        @click="e1 = 4"
                      >
                        Prev
                      </v-btn>
                      <v-btn
                        :ripple="false"
                        :elevation="0"
                        class="
                          font-weight-bold
                          text-xs
                          btn-default
                          bg-gradient-default
                          py-5
                          px-6
                          mt-6
                          mb-2
                          me-2
                          ms-auto
                        "
                        color="primary"
                      >
                        Finish
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-col>
          </v-row>
        </v-stepper>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'SignupWizard',
    data() {
      return {
        accountType: '',
        e1: 1,
        toggle_exclusive: 2,
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        company: '',
      }
    },
  }
</script>
